import { AxiosResponse } from "axios";
import {
  CreatePaymentMethodOpts,
  ListPaymentMethodsOpts,
  ListUserPaymentMethodsOpts,
  PaymentMethod,
  UpdatePaymentMethodOpts,
} from "../../../models/Api/PaymentMethods";
import { IGetResponse } from "../../../models/Api";
import { axiosInstance } from "../../../../../axiosInstance";

export interface IListResponse<T> {
  data: {
    items: [T];
    total: number;
    has_more: boolean;
    next_url: string | null;
  };
  success: boolean;
}

export const listUserPaymentMethods = async (
  payload: ListUserPaymentMethodsOpts
): Promise<AxiosResponse<IListResponse<PaymentMethod>>> => {
  const params = {};
  if (
    payload.excludedFromBackOffice !== null &&
    payload.excludedFromBackOffice !== undefined
  ) {
    params["excluded_from_bo[eq]"] = payload.excludedFromBackOffice;
  }

  return axiosInstance.get(`/users/${payload.userId}/payment_methods`, {
    params,
  });
};

export const listPaymentMethods = async (
  payload: ListPaymentMethodsOpts
): Promise<AxiosResponse<IListResponse<PaymentMethod>>> => {
  const params = {
    offset: payload.offset,
    ...(payload.limit && {
      limit: payload.limit,
    }),
  };
  params["excluded_from_bo[eq]"] = payload.excludedFromBackOffice;

  return axiosInstance.get("/payment_methods", { params });
};

export const createPaymentMethod = async (
  payload: CreatePaymentMethodOpts
): Promise<AxiosResponse<IGetResponse<PaymentMethod>>> => {
  return axiosInstance.post("/payment_methods", payload);
};

export const getPaymentMethod = async (
  id: string
): Promise<AxiosResponse<IGetResponse<PaymentMethod>>> => {
  return axiosInstance.get(`/payment_methods/${id}`);
};

export const updatePaymentMethod = async (
  payload: UpdatePaymentMethodOpts
): Promise<AxiosResponse<IGetResponse<PaymentMethod>>> => {
  const { id, ...params } = payload;

  return axiosInstance.put(`/payment_methods/${id}`, params);
};

export const deletePaymentMethod = async (
  id: number
): Promise<AxiosResponse<IGetResponse<PaymentMethod>>> => {
  return axiosInstance.delete(`/payment_methods/${id}`);
};
